import React from 'react'
import { useState } from 'react'
import { ReactComponent as ArrowIcon} from '../../../images/icons/arrow.svg'

const Item = ({Value}) => {
    const[open,setOpen] = useState(false);
  return (
    <div className={open?'faq_item_container active':'faq_item_container'}>
      <div className='faq_item_question' onClick={()=>{setOpen(!open);}}>
        <h4>{Value.question}</h4><span><ArrowIcon width={'20px'} height={'20px'}/></span>
      </div>
      <div className='faq_item_answer'>
        {
          Value.answer.map((item,index)=>{
            return(
              <p key={index}>{item}</p>
            )
          })
        }
      </div>
    </div>
  )
}

export default Item
